// extracted by mini-css-extract-plugin
export default {"pageWrapper":"TqKBkbg","imgWrapper":"f2uw3Ii","homeIcon":"q2Src3L","loginWrapper":"w0ecud0","loginContent":"Cj_h8XC","title":"nsyj4n2","subtitle":"aS3sXR7"};